import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Table';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 3C3.33579 3 3 3.33579 3 3.75V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V3.75C21 3.33579 20.6642 3 20.25 3H3.75ZM19.5 13.5V9H12.75V13.5H19.5ZM12.75 15H19.5V19.5H12.75V15ZM11.25 13.5V9H4.5V13.5H11.25ZM4.5 15H11.25V19.5H4.5V15ZM19.5 7.5H4.5V4.5H19.5V7.5Z" fill="currentColor"/>
  </svg>
`;

const TableIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.75 3C3.33579 3 3 3.33579 3 3.75V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V3.75C21 3.33579 20.6642 3 20.25 3H3.75ZM19.5 13.5V9H12.75V13.5H19.5ZM12.75 15H19.5V19.5H12.75V15ZM11.25 13.5V9H4.5V13.5H11.25ZM4.5 15H11.25V19.5H4.5V15ZM19.5 7.5H4.5V4.5H19.5V7.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: TableIcon,
  IconSvg: IconSvg
} as IconType;
